import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/**
 * The badge owns its shape and its three fills; the outer look (border, glow, plate
 * colour) stays at the call site so the hero keeps its accent ring and the header its
 * plate.
 */
export const getCompetitionCrestStyles = (theme: Theme) =>
  StyleSheet.create({
    root: {
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    },
    /** Dark league crests (the PL lion, most club marks) only read on a light plate. */
    plate: { backgroundColor: theme.white },
    /**
     * Anchored, but sized inline by the caller. An absolutely positioned `<img>` with only
     * `inset: 0` and no width/height keeps its INTRINSIC size on web (CSS treats a replaced
     * element's `width: auto` as its own size, not as "stretch to both insets"), so the flag
     * silently failed to fill the badge — caught in a Storybook screenshot, not by any assertion.
     */
    flagImage: { position: 'absolute', top: 0, left: 0 },
    monogram: { fontWeight: '700' },
  });
